import React, { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import ReactStars from "react-rating-stars-component";
import { useDispatch, useSelector } from "react-redux";
import { getMarketPlaceRating, getVenueRating } from "store/slice/profile";
import { getMaxValue } from "helper/appConstant";
import { useScreenType } from "component/common/screenType";
import Button from "component/ui/Button";
import TabSwitcher from "component/ui/Tabs";
import PageHeading from "component/ui/PageHeading";
import PageContainer from "component/ui/PageContainer";
import { useLoginData } from "component/common/loginData";

const RatingBox = ({ data }) => {
  return (
    <>
      <div className="group rounded-xl p-4 bg-gray-100 shadow-sm hover:shadow-md transition-all duration-300 my-3 border border-gray-100">
        <div className="flex gap-4">
          {/* Avatar */}
          <div
            style={{
              backgroundImage: `url("${data?.reviewFromData?.imageUrl}")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="h-16 w-16 border border-gray-300 rounded-full flex-shrink-0 flex items-center justify-center shadow-sm ring-2 ring-white"
          >
            {!data?.reviewFromData?.imageUrl && (
              <span className="text-black text-lg font-semibold">
                {(data?.ratingType == 2
                  ? data?.reviewFromUserName
                  : data?.reviewFromData?.name
                )?.charAt(0)}
              </span>
            )}
          </div>

          {/* Header Content */}
          <div className="flex-1 min-w-0">
            <h3 className="text-gray-900 text-base font-semibold truncate capitalize">
              {data?.ratingType == 2
                ? data?.reviewFromUserName
                : data?.reviewFromData?.name}
            </h3>
            <div className="mt-1">
              <ReactStars
                count={5}
                key={String(data?.rating ?? "0")}
                value={data?.rating || 0}
                size={18}
                isHalf={true}
                activeColor="#2bace2"
                edit={false}
              />
            </div>
          </div>
        </div>

        {/* Review Content */}
        <div className="mt-4 space-y-2">
          <div className="text-sm font-medium text-cyan-600 ">
            {data?.ratingType == 2 ? data?.productTitle : data?.sportName}
          </div>
          <p className="text-gray-700 text-sm leading-relaxed">
            {data?.description}
          </p>
        </div>
      </div>
    </>
  );
};
function Rating() {
  const [ratingType, setRatingType] = useState("2");
  const [ratingData, setRatingData] = useState({});
  const dispatch = useDispatch();
  const userData = useLoginData();
  const screenType = useScreenType();
  const { marketPlaceRatingData, venueRatingData } = useSelector(
    (state) => state.profile
  );

  useEffect(() => {
    if (!marketPlaceRatingData) {
      fetchMarketPlaceRating();
    }
  }, []);

  //   set market place and venue rating data
  useEffect(() => {
    if (ratingType != "3") {
      setRatingData(marketPlaceRatingData);
    } else {
      setRatingData(venueRatingData);
    }
  }, [marketPlaceRatingData, venueRatingData]);

  //   fetch market place rating
  const fetchMarketPlaceRating = (page) => {
    let request = {
      language: "en",
      ratingType: 2,
      userId: userData?.id,
      page: page ?? 1,
      limit: 10,
    };
    dispatch(getMarketPlaceRating(request));
  };

  //   fetch venue rating
  const fetchVenueRating = (page) => {
    let request = {
      language: "en",
      ratingType: 3,
      userId: userData?.id,
      page: page ?? 1,
      limit: 10,
    };
    dispatch(getVenueRating(request));
  };

  //   handle fetching rating data
  const handleManageRatingType = (type) => {
    setRatingType(type);
    if (type == "2") {
      if (marketPlaceRatingData) {
        setRatingData(marketPlaceRatingData);
      } else {
        fetchMarketPlaceRating();
      }
    } else {
      if (venueRatingData) {
        setRatingData(venueRatingData);
      } else {
        fetchVenueRating();
      }
    }
  };
  //   Rating menu
  const RatingMenu = [
    {
      id: 1,
      title: "MarketPlace Ratings",
      color: "bg-gradient-to-t from-[#F178B0] to-[#DB0C6E]",
      icon: <FaStar color="orange" size={25} />,
      border: ratingType == "2",
      onClick: () => handleManageRatingType("2"),
    },
    {
      id: 2,
      title: "Venue Ratings",
      color: "bg-gradient-to-t from-[#B2BBFF] to-[#2BACE2]",
      icon: <FaStar color="orange" size={25} />,
      border: ratingType == "3",
      onClick: () => handleManageRatingType("3"),
    },
  ];
  return (
    // <div className="md:p-5 py-5 px-3 min-h-screen bg-gray-100">
    //   <div className="container mx-auto">
    <PageContainer>
      <PageHeading
        title={"Rating"}
        Subtitle={"Your feedback helps our community grow"}
      />

      <div className="bg-white min-h-screen rounded-md mt-5">
        <TabSwitcher tabs={RatingMenu} />

        <div className="md:px-6 px-3">
          {/* star */}
          <div className="flex justify-center ">
            <ReactStars
              count={5}
              key={String(ratingData?.averageRating ?? "0")}
              value={ratingData?.averageRating || 0}
              size={screenType == "mobile" ? 40 : 60}
              isHalf={true}
              activeColor="#2bace2"
              edit={false}
            />
          </div>
          {/* rating and review */}
          {ratingData?.data?.map((item) => (
            <RatingBox data={item} key={item?._id} />
          ))}
          {/* view more button */}
          {ratingData?.totalRating > ratingData?.data?.length && (
            <div className="flex justify-center py-3">
              <Button
                children={"View More"}
                onClick={() => {
                  if (ratingType == "3") {
                    fetchVenueRating(
                      getMaxValue(ratingData?.data?.length, 10) + 1
                    );
                  } else {
                    fetchMarketPlaceRating(
                      getMaxValue(ratingData?.data?.length, 10) + 1
                    );
                  }
                }}
              />
            </div>
          )}
          {ratingData?.data?.length == 0 && (
            <div className="h-[50vh] bg-gray-200 font-semibold text-xl flex justify-center items-center py-3">
              No Data Found
            </div>
          )}
        </div>
      </div>
      {/* </div>
    </div> */}
    </PageContainer>
  );
}

export default React.memo(Rating);
